// COI status for carrier assignment. Returns null when the insurance is fine (or
// unknown — an undefined coiOnFile means the object carries no COI data).
export function coiWarningText(coiOnFile?: boolean, coiExpiresAt?: string | null): string | null {
  if (coiOnFile === false) return 'No Certificate of Insurance is on file for this carrier.';
  if (coiExpiresAt && coiExpiresAt.slice(0, 10) < new Date().toISOString().slice(0, 10)) {
    const [y, m, d] = coiExpiresAt.slice(0, 10).split('-');
    return `The Certificate of Insurance on file expired ${m}/${d}/${y}.`;
  }
  return null;
}
